var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLikeGradient = function SvgLikeGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#like-gradient_svg__a)",
    d: "M15.5 1.664h-10C4.117 1.664 3 2.772 3 4.14v9.092c0 1.366 1.117 2.475 2.5 2.475h.633c.667 0 1.3.258 1.767.725l1.425 1.408c.65.642 1.708.642 2.358 0l1.425-1.408a2.505 2.505 0 0 1 1.767-.725h.625c1.383 0 2.5-1.109 2.5-2.475V4.139c0-1.367-1.117-2.475-2.5-2.475Zm-4.767 10.8a.888.888 0 0 1-.466 0C9.183 12.09 6.75 10.547 6.75 7.922a2.091 2.091 0 0 1 2.083-2.091c.684 0 1.284.325 1.667.833a2.075 2.075 0 0 1 1.667-.833c1.15 0 2.083.933 2.083 2.091-.008 2.625-2.433 4.167-3.517 4.542Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "like-gradient_svg__a",
    x1: 3,
    x2: 18,
    y1: 9.992,
    y2: 9.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })))));
};
export default SvgLikeGradient;